import { FC } from "react";
import { Portal } from "react-portal";

import { clsxMerge } from "shared/lib/helpers";
import { CloseIcon } from "shared/ui/icons";
import SidebarV2 from "shared/ui/sidebarV2";
import { SidebarSlide } from "shared/ui/sidebarV2/components/slide";
import { EmailTemplatesSidebarContentV2 } from "@/components/modules/email-templates-sidebar/content/v2";
import { EmailTemplatesProvider } from "./context";
import { EmailTemapltesSidebarEvents } from "./events";

interface EmailTemplatesSidebarPropsI {
  isOpen: boolean;
  onClose?: () => void;
}

export const EmailTemplatesSidebar: FC<EmailTemplatesSidebarPropsI> = ({
  isOpen,
  onClose = () => {},
}) => {
  return (
    // @ts-ignore
    <Portal>
      <SidebarV2 isOpen={isOpen} onClose={onClose}>
        <SidebarSlide size="xl" contentClassName="p-0 bg-white">
          <button
            className={clsxMerge(
              "btn btn-square btn-sm",
              "absolute right-2 top-2",
              "z-20"
            )}
            onClick={onClose}
          >
            <CloseIcon className="w-6 text-white" />
          </button>

          {isOpen && (
            <EmailTemplatesProvider>
              <EmailTemapltesSidebarEvents />
              <EmailTemplatesSidebarContentV2 />
            </EmailTemplatesProvider>
          )}
        </SidebarSlide>
      </SidebarV2>
    </Portal>
  );
};
